import React, { useEffect, useState } from 'react';
import { useListProjectsQuery } from '../../api/project';
import { Link } from 'react-router-dom';
import LoadingSpiner from '../Loader/LoadingSpiner';
import { FaExclamationCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedProjectIds, selectProjectIds, selectSelectedProjectIds } from '../../Store/projectSlice';
import StarToggle from '../Favorite/StarToggle';

export interface Project {
    id: string;
    name: string;
    description: string;
    image_count: number;
    created_by: string;
    owner_id: string;
    s3_path: string;
    status: string;
    tags: string;
}

interface ProjectListProps {
    setProjectsAreSelected: Function;
}

export default function ProjectList(props: ProjectListProps) {

    const { setProjectsAreSelected } = props
    const dispatch = useDispatch();
    const selectedProjects = useSelector(selectSelectedProjectIds);

    const { data: projects, isLoading, isError } = useListProjectsQuery({});

    useEffect(() => {
        if (selectedProjects.length > 0) {
            setProjectsAreSelected(true)
        } else {
            setProjectsAreSelected(false)
        }
    }, [selectedProjects, setProjectsAreSelected])

    if (isLoading) return <div className='text-center mt-6'><LoadingSpiner/></div>;
    if (isError) return <div><p className='text-center mt-6'><FaExclamationCircle className='inline mr-2'/> Error loading projects</p></div>;

    const handleProjectSelect = (projectId: string) => { // or number, depending on the id's type
        const currentIndex = selectedProjects.indexOf(projectId);
        const newSelectedProjects = [...selectedProjects];

        if (currentIndex === -1) {
            newSelectedProjects.push(projectId);
        } else {
            newSelectedProjects.splice(currentIndex, 1);
        }

        dispatch(selectProjectIds(newSelectedProjects));
    };

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked && projects) {
            const newSelectedProjects = projects.map((project: any) => project.id);
            dispatch(selectProjectIds(newSelectedProjects));
            return;
        }
        dispatch(clearSelectedProjectIds());
    };

    // Determine whether the select all checkbox should be checked
    const isAllSelected = projects?.length === selectedProjects.length;

    return (
        <div className="overflow-x-auto mt-6">
            <table className="table w-full">
                <thead>
                    <tr>
                        <th className="w-12">
                            <label>
                                <input
                                    type="checkbox"
                                    className="checkbox"
                                    onChange={handleSelectAllClick}
                                    checked={isAllSelected}
                                // indeterminate={selectedProjects.length > 0 && selectedProjects.length < projects?.length}
                                />
                            </label>
                        </th>
                        <th className="w-12"></th>
                        <th>Project Name</th>
                        <th>Status</th>
                        <th>Who can access</th>
                        <th className="text-right"></th>
                    </tr>
                </thead>
                <tbody>
                    {projects?.map((project: Project) => (
                        <tr key={project.id}>
                            <th className="w-12">
                                <label>
                                    <input
                                        type="checkbox"
                                        className="checkbox"
                                        onChange={() => handleProjectSelect(project.id)}
                                        checked={selectedProjects.includes(project.id)}
                                    />
                                </label>
                            </th>
                            <td className="w-12">
                                <StarToggle entityId={project.id} entityType="Project" />
                            </td>
                            <td>
                                <div className="flex items-center space-x-3">
                                    <div><Link to={`/projects/${project.id}`}>{project.name}</Link></div>
                                </div>
                            </td>
                            <td>
                                <div className="flex items-center space-x-3">
                                    <div>{project.status}</div>
                                </div>
                            </td>
                            <td>
                                Only you can
                            </td>
                            <td className="text-right">
                                <button className="btn btn-ghost btn-xs">details</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
